import { z } from 'zod'
import { ALL_TRACKING_PARAMETERS } from '@nwwp/utils'

export const ANONYMOUS_TRACKING_PARAMS_TTL_SECONDS = 24 * 60 * 60

export type TrackingParameter = (typeof ALL_TRACKING_PARAMETERS)[number]
export type TrackingParams = Partial<Record<TrackingParameter, string>>

const trackingParamFields = Object.fromEntries(
  ALL_TRACKING_PARAMETERS.map((key) => [key, z.string().optional()])
) as Record<TrackingParameter, z.ZodOptional<z.ZodString>>

export const trackingParamsSchema = z.object(trackingParamFields).strict()

export const anonymousTrackingParamsSchema = trackingParamsSchema.extend({
  anonymous_id: z.string().min(1),
  expires_at: z.number().int().positive(),
})

export type AnonymousTrackingParams = z.infer<typeof anonymousTrackingParamsSchema>

export type UpsertAnonymousTrackingParams = {
  anonymous_id: string
  params: Record<string, string>
}

export function pickPersistableTrackingParams(params: Record<string, string>): TrackingParams {
  const result: TrackingParams = {}

  for (const key of ALL_TRACKING_PARAMETERS) {
    const value = params[key]
    if (value) {
      result[key] = value
    }
  }

  return result
}
